import {AwsRum} from 'aws-rum-web'
import config from "../config";

const RUM = config.RUM
let rumClient: AwsRum | null = null;

if (RUM.isEnabled === true) {
    try {
        console.log('Initializing CloudWatch RUM with:', RUM);
        rumClient = new AwsRum(
            RUM.applicationId,
            RUM.applicationVersion,
            RUM.applicationRegion,
            RUM.config
        )
        console.log('CloudWatch RUM initialized successfully', rumClient);
    } catch (error) {
        console.warn('CloudWatch RUM initialization error:', error);
    }
} else {
    console.log('CloudWatch RUM is disabled');
}

export default rumClient;
